import { Component } from "react";

import { Link, withRouter } from "react-router-dom";
import TitleBar from "../../components/ui/TitleBar";
import RectButton from "../../components/ui/button/RectButton";
import CreditCardInfo from "../../components/CreditCardInfo";
import SubscriptionPlan from "../../components/SubscriptionPlan";

import "./style.scss";
import AddCreditcardSectionBox from "../../components/AddCreditcardSectionBox";
class Subscriptions extends Component {
    state = {
        addingCrediCard:false
    }
    render() {
        return (
            <>
                <div className="full-container subscriptions">
                    <section className="section-box row plans">
                        <SubscriptionPlan className="platinum" title="Platinum Plan" price={158} discount={20} description="Prepay for 50 cards per month at a 20% discount. Get 20% off all orders beyond your 50." />
                        <SubscriptionPlan className="gold" title="Gold Plan" price={83} discount={15} description="Prepay for 25 cards per month at a 15% discount. Get 15% off all orders beyond your 25." popular={true} />
                        <SubscriptionPlan className="silver" title="Silver Plan" price={35} discount={10} description="Prepay for 10 cards per month at a 10% discount. Get 10% off all orders beyond your 10." />
                    </section>

                    <section className="section-box row other-details">
                        <CreditCardInfo onAddNew={()=>this.setState({addingCrediCard:true})} />
                        <section className="details">
                            <TitleBar title="Details" />
                            <div className="box">
                                <p>All plans include credit for cards and domestic postage. International orders may use additional credit. Discount extends past credit allotment; the discount will continue to apply after the credit is exhausted. All plans reset on the 30-day anniversary of joining and can be canceled at any time.</p>
                            </div>
                        </section>
                    </section>

                    { this.state.addingCrediCard ? <AddCreditcardSectionBox onAddCard={()=>this.setState({addingCrediCard:false})} onCancel={()=>this.setState({addingCrediCard:false})} /> : null }                    

                    <div className="section-box">
                        <Link className="subscribe-bt" to="/thanks-for-subscribing"><RectButton className="bigger" text="SUBSCRIBE NOW" /></Link>
                    </div>                    
                </div>
            </>
        )
    }
}

export default withRouter(Subscriptions);